import { coverConstants } from '../constants';

export const coverReducer = (state = {}, action) => {
    switch(action.type) {
        case coverConstants.GET_COVER_REQUEST:
            return {
                ...state,
                getCoverProcess: true
            }

        case coverConstants.GET_COVER_SUCCESS:
            return {
                ...state,
                cover: { ...action.payload },
                getCoverProcess: false,
                getCoverError: false
            }
        case coverConstants.GET_COVER_FAILURE:
            return {
                ...state,
                getCoverProcess: false,
                getCoverError: true
            }

        case coverConstants.UPLOAD_COVER_FAILURE:
            return {
                ...state,
                uploadCoverProcess: false,
                uploadCoverError: true
            }
            
        case coverConstants.UPLOAD_COVER_REQUEST:
            return {
                ...state,
                uploadCoverProcess: true
            }
        
        case coverConstants.UPLOAD_COVER_SUCCESS:
            return {
                ...state,
                cover: { ...action.payload },
                uploadCoverProcess: false,
                uploadCoverError: false,
            }

        case coverConstants.UPDATE_COVER_FAILURE:
            return {
                ...state,
                updateCoverProcess: false,
                updateCoverError: true
            }
            
        case coverConstants.UPDATE_COVER_REQUEST:
            return {
                ...state,
                updateCoverProcess: true
            }
        
        case coverConstants.UPDATE_COVER_SUCCESS:
            return {
                ...state,
                cover: { ...action.payload },
                updateCoverProcess: false,
                updateCoverError: false,
            }

        case coverConstants.DELETE_COVER_FAILURE:
            return {
                ...state,
                deleteCoverProcess: false,
                deleteCoverError: true
            }
            
        case coverConstants.DELETE_COVER_REQUEST:
            return {
                ...state,
                deleteCoverProcess: true
            }
        
        case coverConstants.DELETE_COVER_SUCCESS:
            return {
                ...state,
                cover: undefined,
                deleteCoverProcess: false,
                deleteCoverError: false,
            }

        case coverConstants.RESET_COVER:
            return {
                ...state,
                cover: undefined,
            }

        default:
            return state;
    }
}

export default coverReducer;


// WEBPACK FOOTER //
// ./src/reducers/cover.js